import React from 'react';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class BusinessLicenseApplicationSuccess extends React.Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('BusinessLicenseApplicationSuccess', this.props);
		return (
			<div className="BusinessLicenseApplicationSuccess w-full py-4">
				Success!
				<div className="grid">
					<div className="lg:justify-self-end mb-4 lg:mb-0">
						<SecondaryButton
							label="Continue"
							onClick={this.props.continueLocation}
						/>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}
}
